module.exports = __webpack_public_path__ + "static/S-Factor_MarketingAssistant_PD-fe7ca50057d1299afa053fd2370d7eb8.pdf";